// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import type { IButtonProps } from "@fluentui/react";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import { ActionControlSize } from "@1js/acui-common";

import { renderLargeControlText } from "../renderLargeControlTextFunction";

export const getOnRenderText = memoizeFunction((size?: ActionControlSize) => {
  return (
    buttonProps?: IButtonProps,
    defaultRender?: (buttonProps?: IButtonProps) => JSX.Element | null
  ): JSX.Element | null => {
    if (size === ActionControlSize.Large && buttonProps && buttonProps.text) {
      return renderLargeControlText(buttonProps.text);
    }

    return defaultRender ? defaultRender(buttonProps) : null;
  };
});
